import React from "react";
import {observer} from "mobx-react-lite";
import {FinancialFilters} from "../financial-dashboard/financialFilters";
import {BeforeAfterChart} from "./BeforeAfterChart";
import PipelineDashboardController from "./PipelineDashboardController";
import {useSitStores} from "../../../stores";
import i18n from "../../../i18n/i18n";

const fin = (k: string) => i18n.t(`fin.${k}`, {ns: 'sit'});

export const PipelineDashboard: React.FC = observer(() => {
    const C = PipelineDashboardController;
    const {fbStore} = useSitStores();
    return (
        <div className="pipeline-dashboard-page">
            <FinancialFilters/>

            <div className="sit-fin-grid">
                <div className="sit-card">
                    <div className="sit-cardhead">
                        <h3 className="sit-cardtitle">{fin('costSavings')}</h3>
                    </div>
                    <BeforeAfterChart data={C.ppvSavings} loading={fbStore.pipelineRM.busy}/>
                </div>
                <div className="sit-card">
                    <div className="sit-cardhead">
                        <h3 className="sit-cardtitle">{fin('costAvoidance')}</h3>
                    </div>
                    <BeforeAfterChart data={C.nonPpvSavings} loading={fbStore.pipelineRM.busy}/>
                </div>
            </div>
        </div>
    );
});
